<template>
  <el-dialog
    id="auth-dialog"
    title="温馨提示"
    :visible.sync="localDialogVisible"
    width="25%"
    :append-to-body="true"
  >
    <span style="display: flex; justify-content: center; font-size: 15px">{{
      tipType === 1 ? tip1 : tipType === 2 ? tip2 : tipType === 3 ? tip3 : ""
    }}</span>
    <span slot="footer" class="dialog-footer">
      <el-button
        v-if="tipType === 1"
        type="primary"
        size="medium"
        @click="$router.push('/authentication/shop-authentication')"
        >去认证</el-button
      >
      <el-button
        v-if="tipType === 2 || tipType === 3"
        type="primary"
        size="medium"
        @click.stop="localDialogVisible = false"
        >确定</el-button
      >
    </span>
  </el-dialog>
</template>
<script>
export default {
  name: "auth-dialog",
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    tipType: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      tip1: `完成${this.$store.getters["user/shopOrStudioTag"]}认证后，即可解锁该模块功能`,
      tip2: "试运营考核通过后，即可解锁该模块功能",
      tip3: `您的${this.$store.getters["user/shopOrStudioTag"]}处于${
        this.$store.getters["user/shopOrStudioTag"] === "工作室"
          ? "下线"
          : "关店"
      }状态，该模块功能无法使用`,
      localDialogVisible: this.dialogVisible,
    };
  },
  watch: {
    dialogVisible(newValue) {
      this.localDialogVisible = newValue;
    },
    localDialogVisible(newValue) {
      this.$emit("update:dialogVisible", newValue);
    },
  },
  mounted() {
    if (document.querySelector("#auth-dialog")) {
      document.querySelector("#auth-dialog").addEventListener("click", (e) => {
        e.preventDefault();
      });
    }
  },
  methods: {},
  beforeDestroy() {
    if (document.querySelector("#auth-dialog")) {
      document
        .querySelector("#auth-dialog")
        .removeEventListener("click", (e) => {
          e.preventDefault();
        });
    }
  },
};
</script>
<style scoped lang="scss">
::v-deep .el-dialog__footer {
  text-align: center;
}
::v-deep .el-dialog {
  display: flex;
  flex-direction: column;
  margin: 0 !important;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-height: calc(100% - 30px);
  max-width: calc(100% - 30px);
}
::v-deep .el-dialog .el-dialog__body {
  flex: 1;
  overflow: auto;
}
</style>
